import { render, staticRenderFns } from "./Transcription.vue?vue&type=template&id=388ee041&scoped=true"
import script from "./Transcription.vue?vue&type=script&lang=js"
export * from "./Transcription.vue?vue&type=script&lang=js"
import style0 from "./Transcription.vue?vue&type=style&index=0&id=388ee041&prod&scoped=true&lang=scss"
import style1 from "./Transcription.vue?vue&type=style&index=1&id=388ee041&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ee041",
  null
  
)

export default component.exports